// src/pages/Dashboard.js

import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles'; // Updated import path for styled
import SummaryCard from './SummaryCard'; // Corrected import path
import AttendanceChart from './AttendanceChart'; // Corrected import path
import RecentAttendanceList from './RecentAttendanceList';
import axios from "axios";
import { useQuery } from "react-query";
import { url, localUrl } from "./../../BaseUrl";
// Styled component for consistent Paper styling
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  // color: theme.palette.text.secondary,
}));

const Dashboard = () => {
  const date = new Date();
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  const { isLoading, error, data } = useQuery("getAttendance", async () => {
    const token = sessionStorage.getItem("token");

    const response = await axios.get(
      `${url}/api/auth/getAttendance`, // Ensure the correct endpoint
      {
        headers: {
          Authorization: `Bearer ${token}`, // Send token in the Authorization header
          "Content-Type": "application/json",
        },
      }
    );

    return response.data; // Return the fetched data
  });


 const todayAttendance= data && data?.attendance
    .filter((attendanceEntry) => {
      // Format attendanceEntry.date to 'MM/DD/YYYY' format
      const entryDate = new Date(attendanceEntry.date).toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
      });
      return entryDate === formattedDate;
    })

    const presentStudents = todayAttendance && todayAttendance[0]?.records.filter((student) => student.status === "Present");
    const absentStudents = todayAttendance && todayAttendance[0]?.records.filter((student) => student.status === "Absent");
    const totalStudents = todayAttendance && todayAttendance[0]?.records.length;
    
  return (
    <Grid container spacing={3} sx={{ padding: 3 }}>
      {/* Summary Cards */}
      <Grid item xs={12} sm={6} md={3}>
        <SummaryCard title="Total Students" value={totalStudents} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SummaryCard title="Present Today" value={presentStudents?.length} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SummaryCard title="Absent Today" value={absentStudents?.length} />
      </Grid>
      {/* <Grid item xs={12} sm={6} md={3}>
        <SummaryCard title="Classes Today" value="5" />
      </Grid> */}

      {/* Attendance Overview Chart */}
      <Grid item xs={12} md={8}>
        <StyledPaper>
          <Typography variant="h6" gutterBottom>
            Attendance Overview
          </Typography>
          <AttendanceChart chartData={data}/>
        </StyledPaper>
      </Grid>

      {/* Recent Attendance Records */}
      <Grid item xs={12} md={4}>
        <StyledPaper>
          <Typography variant="h6" gutterBottom>
            Recent Attendance
          </Typography>
          {/* TODO: Insert Recent Attendance Component or List Here */}
          {/* Example Placeholder */}
          
          <RecentAttendanceList recentList={data}/>
          {! data && <Typography variant="body1">No recent records available.</Typography>}
        </StyledPaper>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
